import { Divider, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import PortfolioModal from "../../ServiceList Components/ServiceDetails/PortfolioModal/PortfolioModal";
import { tokens } from "../../../store/tokens";

const CoverOverlay = ({ title }) => (
  <>
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        backgroundImage: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.7))",
      }}
    />
    {title && (
      <Box sx={{ position: "absolute", bottom: 14, left: 14 }}>
        <Typography variant="subtitle2" sx={{ color: tokens.color.white, fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
    )}
  </>
);

const Portfolios = (props) => {
  const { portfolio } = props;

  const [hoverKey, setHoverKey] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Stack direction="row" justifyContent={"space-between"} alignItems="center" sx={{ pb: 1.5 }}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Portfolio
        </Typography>
      </Stack>
      <Divider sx={{ mb: 2, borderColor: tokens.color.line }} />

      <Stack spacing={2}>
        {portfolio?.map((element, portfolioIndex) => {
          const cover = element.pic_object[0];
          const rightPicsList = element.pic_object.slice(1, 5);

          return (
            <Grid container spacing={1} key={cover?.port_refer ?? portfolioIndex}>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{ position: "relative", borderRadius: `${tokens.radius.md}px`, overflow: "hidden" }}
                  // was `classname` (lowercase c) — not a real DOM/React
                  // prop, so this element never actually received a class
                  className="pCon"
                  onMouseOver={() => setHoverKey(cover?.port_refer)}
                  onMouseLeave={() => setHoverKey(null)}
                  onClick={handleOpen}
                >
                  <Box
                    component="img"
                    sx={{ width: "100%", height: "50vh", objectFit: "cover", cursor: "pointer" }}
                    alt={cover?.title ?? "Portfolio cover"}
                    src={cover?.file_url}
                  />
                  {hoverKey === cover?.port_refer && <CoverOverlay title={cover?.title} />}
                </Box>
              </Grid>

              {rightPicsList[0]?.file_url && (
                <Grid item xs={12} md={6}>
                  <Grid container spacing={1} sx={{ height: "51vh" }}>
                    {rightPicsList.map((pic) => (
                      <Grid item xs={6} key={pic?.port_refer}>
                        <Box
                          sx={{
                            position: "relative",
                            height: "23.8vh",
                            borderRadius: `${tokens.radius.md}px`,
                            overflow: "hidden",
                          }}
                          className="pCon"
                          onMouseOver={() => setHoverKey(pic?.port_refer)}
                          onMouseLeave={() => setHoverKey(null)}
                          onClick={handleOpen}
                        >
                          <Box
                            component="img"
                            sx={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                            alt={pic?.title ?? "Portfolio image"}
                            src={pic?.file_url}
                          />
                          {hoverKey === pic?.port_refer && <CoverOverlay title={pic?.title} />}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}
            </Grid>
          );
        })}
      </Stack>

      {portfolio?.length > 0 && open && (
        <PortfolioModal open={open} portfolio={portfolio} handleClose={handleClose} />
      )}
    </Box>
  );
};

export default Portfolios;
